__webpack_require__.p = "/mocknikers/";